import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const RouteWithLayout = props => {
  const { layout: Layout, component: Component, condition, conditionPathRedirect, ...rest } = props;

  if (typeof condition === 'undefined') {
    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        )}
      />
    );
  } else {
    return (
      <Route {...rest} render={(matchProps) => (
        condition === true ?
          <Layout>
            <Component {...matchProps} />
          </Layout>
          :
          <Redirect to={conditionPathRedirect} />
      )} />
    )
  }
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  condition: PropTypes.bool,
  conditionPathRedirect: PropTypes.string
};

RouteWithLayout.defaultProps = {
  condition: undefined,
  conditionPathRedirect: '/'
}

export default RouteWithLayout;